import { render, staticRenderFns } from "./ProductVendor.vue?vue&type=template&id=1c7888b9"
import script from "./ProductVendor.vue?vue&type=script&lang=js"
export * from "./ProductVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports